import {
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const stripSchemeAndSlashes = (value) => {
  if (!value) return '';
  return String(value).replace(/^https?:\/\//i, '').replace(/\/+$/g, '');
};

/**
 * Transform criteria.url into Branding URL sub-item data.
 * Legacy behavior: if missing, show "No URL was found.", otherwise show URL and its length.
 *
 * @param {Object} urlCriteria - criteria.url
 * @param {string} fallbackUrl - apiData.url (top-level)
 */
export const transformBrandingUrl = (urlCriteria, fallbackUrl = '') => {
  const wooRankImportance = urlCriteria?.importance ?? 0;
  const wooRankSolvability = urlCriteria?.solvability ?? 0;

  const rawRequestedHost = urlCriteria?.data?.host?.requested;
  const rawUrl = urlCriteria?.data?.url;

  const displayUrl = stripSchemeAndSlashes(rawRequestedHost || rawUrl || fallbackUrl);
  const length = displayUrl ? displayUrl.length : 0;

  const isEmpty = !displayUrl;

  return {
    // Branding legacy view is binary: found vs not found (no warnings)
    status: isEmpty ? 'error' : 'success',
    iconType: isEmpty ? 'error' : 'success',
    importance: getImportance(wooRankImportance),
    solvability: getSolvability(wooRankSolvability),
    isEmpty,
    message: isEmpty ? 'No URL was found.' : null,
    data: isEmpty
      ? null
      : {
          displayUrl,
          length,
        },
  };
};

export default transformBrandingUrl;


